import { render, staticRenderFns } from "./BranchStaffSales.vue?vue&type=template&id=10538875"
import script from "./BranchStaffSales.vue?vue&type=script&lang=js"
export * from "./BranchStaffSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports